import React from "react"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import { IExpensesPayrollData } from "../../../models"
import ApprovedIcon from "../../../components/expense/ApprovedIcon"
interface IProps {
	payrollExpenses: IExpensesPayrollData[]
}

const PayrollTimeByHierarchyEmployeeDayAmountExpenseRow: React.SFC<IProps> = (props: IProps) => {
	var nonTimeExpenses = props.payrollExpenses.filter(exp => !exp.IsTime);
	if (nonTimeExpenses.length === 0) return null;

	var formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	});

	return (
		<Table style={{ backgroundColor: "none" }} selectable={false}>
			<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
				<TableRow>
					<TableHeaderColumn className="TextOverflow" title={strings.Expense} style={styles.inCol}>{strings.Expense}</TableHeaderColumn>
					<TableHeaderColumn className="TextOverflow" title={strings.Amount} style={styles.outCol}>{strings.Amount}</TableHeaderColumn>
					{AccountStore.getEmployeeApproveTimecardEnabled() &&
						<TableHeaderColumn className="TextOverflow" title={strings.EMP_Approved} style={styles.approvedCol}>{strings.EMP_Approved}</TableHeaderColumn>
					}
					<TableHeaderColumn className="TextOverflow" title={strings.Approved} style={styles.approvedCol}>{strings.Approved}</TableHeaderColumn>
					<TableHeaderColumn className="TextOverflow" title={strings.Pay_Type} style={styles.approvedCol}>{strings.Pay_Type}</TableHeaderColumn>
					{AccountStore.getScheduleEnabled() &&
						<TableHeaderColumn className="TextOverflow" title={strings.Shift_Note} style={styles.approvedCol}>{strings.Shift_Note}</TableHeaderColumn>
					}
				</TableRow>
			</TableHeader>
			<TableBody displayRowCheckbox={false}>
				{nonTimeExpenses.map((expense, index) => {
					const payTypeObjList = AccountStore.getCurrentAccount().PayTypes.filter(ptt => ptt.Id === expense.PayTypeId)
					const payTypeLabel = payTypeObjList && payTypeObjList.length > 0 ? payTypeObjList[0].Name : ""
					return (
						<TableRow key={index}>
							<TableRowColumn style={styles.inCol}>
								{expense.Name}
							</TableRowColumn>
							<TableRowColumn style={styles.outCol}>
								{formatter.format(expense.Amount)}
							</TableRowColumn>
							{AccountStore.getEmployeeApproveTimecardEnabled() &&
								<TableRowColumn style={styles.approvedCol}>
									{expense.EmployeeApproved &&
										<ApprovedIcon
											keyStr={`employee_${expense.Id}`}
											label={strings.Employee_Approved}
											audit={expense.EmployeeApprovalAudit}
										/>
									}
								</TableRowColumn>
							}
							<TableRowColumn style={styles.approvedCol}>
								{expense.SupervisorApproved &&
									<ApprovedIcon
										keyStr={`supervisor_${expense.Id}`}
										label={strings.Supervisor_Approved}
										audit={expense.SupervisorApprovalAudit}
									/>
								}
							</TableRowColumn>
							<TableRowColumn style={styles.approvedCol}>
								{payTypeLabel}
							</TableRowColumn>
							{AccountStore.getScheduleEnabled() &&
								<TableRowColumn style={styles.approvedCol}>
								</TableRowColumn>
							}
						</TableRow>
					)
				})}
			</TableBody>
		</Table>
	)
}

export default PayrollTimeByHierarchyEmployeeDayAmountExpenseRow

const styles = {
	inCol: {
		paddingLeft: 0,
		paddingRight: 10,
		width: 75
	},
	outCol: {
		paddingLeft: 10,
		paddingRight: 0,
		width: 75
	},
	approvedCol: {
		width: 75,
		textAlign: "center"
	}
}
